import { Location } from "@angular/common";

export const HISTORY_DETAIL_FROM_HISTORY_KEY = "historyDetailFromHistory";

export function markHistoryDetailNavigation(): void {
  sessionStorage.setItem(HISTORY_DETAIL_FROM_HISTORY_KEY, "true");
}

export function clearHistoryDetailNavigation(): void {
  sessionStorage.removeItem(HISTORY_DETAIL_FROM_HISTORY_KEY);
}

export function goBackToHistory(location: Location): void {
  if (sessionStorage.getItem(HISTORY_DETAIL_FROM_HISTORY_KEY) === "true") {
    sessionStorage.removeItem(HISTORY_DETAIL_FROM_HISTORY_KEY);
    localStorage.setItem("skipHistoryOnBack", "true");
    localStorage.setItem("skipHistoryOnBackTs", Date.now().toString());
  }
  location.back();
}
